<script setup>
import { onMounted, nextTick } from "vue";
import { useGlobalStore } from "@stores/global.js";
import HeroSlider from "@sections/homepage/HeroSlider.vue";
import FeaturedCollections from "@sections/homepage/FeaturedCollections.vue";
import TeamsSlider from "@sections/homepage/TeamsSlider.vue";
import SubCollections from "@sections/homepage/SubCollections.vue";
import FeaturedProducts from "@sections/homepage/FeaturedProducts.vue";
import InstagramPosts from "@sections/homepage/InstagramPosts.vue";

const global = useGlobalStore();

onMounted(() => {
	nextTick(() => {
		global.setTheme(null, null, null);
	});
});
</script>

<template>
	<HeroSlider />
	<FeaturedCollections />
	<TeamsSlider />
	<SubCollections />
	<FeaturedProducts />
	<InstagramPosts />
</template>
